module.exports = new __parcel__URL__("task-one-illustration.d1a41afc.png").toString();